import axios from 'axios'
// import Api from '@/services/Api'
/* eslint-disable */
export default {
    index() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/RequestAgent/GetAllRequest`)
    },
    accept(agentid, raceid, id) {
        console.log('agentid:' + agentid + '  raceid:' + raceid + '  id:' + id)
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/RequestAgent/SubmitRequest`, null, {
            params: {
                RaceID: raceid,
                AgentID: agentid,
                RequestId: id
            }
        })
    }
}